import { GridCellProps } from '@progress/kendo-react-grid';
import GridCellBase from 'src/components/GridCellBase';
import ExpandCollapseCell from 'src/components/custom-cells/ExpandCollapseCell';
import useVarianceDetails from 'src/hooks/useVarianceDetails';

const VarianceGLCodeColumnsCell = (props: GridCellProps) => {
  const { dataItem } = props;
  const { setVarianceGLPeriods } = useVarianceDetails();

  let { expanded = false, rowId } = dataItem;

  const handleExpendClick = () => {
    setVarianceGLPeriods((prev) =>
      [...prev].map((lineItem) => {
        const glCodeVariances = lineItem.glCodeVariances.map((item) =>
          item.rowId === rowId ? { ...item, expanded: !item.expanded } : item
        );

        return { ...lineItem, glCodeVariances };
      })
    );
  };

  return (
    <GridCellBase {...props} className="k-hierarchy-cell" disableToolTip>
      <ExpandCollapseCell
        title="Expand/Collapse"
        expand={expanded}
        onExpand={handleExpendClick}
        plusIconColor="#0e80b4"
        minusIconColor="#0e80b4"
      />
    </GridCellBase>
  );
};

export default VarianceGLCodeColumnsCell;
